import Vue from 'vue';

export const state = {
    breadCrumb: {
        loading: false,
        data: [
          {
            id: 0,
            text: "My Folder",
            to: { name: "My Folder" },
          },
        ],
    },
    modifyBreadCrumb: {
        loading: false,
        data: [],
    },
}


export const getters = {
}


export const mutations = {
    // BREADCRUMB
    setBreadCrumb: (state, data) => {
        if (data !== null) {
            const index = state.breadCrumb.data.findIndex(
                (item) => item.id === data.id
            );
            let encryptId = Vue.prototype.$encryptRouteID(data.id.toString());

            if (index !== -1) {
                state.breadCrumb.data.splice(index + 1, state.breadCrumb.data.length);
            } else {
                if (state.breadCrumb.data.length > data.depth) {
                    // state.breadCrumb.data.splice(index, state.breadCrumb.data.length);
                    state.breadCrumb.data[state.breadCrumb.data.length - 1].id = data.id;
                    state.breadCrumb.data[state.breadCrumb.data.length - 1].text = data.name.toString();
                    state.breadCrumb.data[state.breadCrumb.data.length - 1].to = {
                        name: "Folder ID",
                        params: { id: encryptId },
                    };
                } else {
                    state.breadCrumb.data.push({
                        id: data.id,
                        text: data.name.toString(),
                        to: { name: "Folder ID", params: { id: encryptId } },
                    });
                }
            }
        }

        // empty na object means default route ni siya (My Folder)
        else {
            state.breadCrumb.data = [state.breadCrumb.data[0]];
        }


        // modify breadcrumbs
        const copyBreadcrumbData = JSON.parse(JSON.stringify(state.breadCrumb.data));
        state.modifyBreadCrumb.data = modifiedBreadCrumb(copyBreadcrumbData);
    },
    setBreadCrumbByID: (state, id) => {
        const index = state.breadCrumb.data.findIndex((item) => item.id == id);

        if (index !== -1) {
            state.breadCrumb.data.splice(index + 1, state.breadCrumb.data.length);
        }

        // modify breadcrumbs
        const copyBreadcrumbData = JSON.parse(JSON.stringify(state.breadCrumb.data));
        state.modifyBreadCrumb.data = modifiedBreadCrumb(copyBreadcrumbData);
    },
    setBreadCrumbByRouteChange: (state, id) => {
        const index = state.breadCrumb.data.findIndex((item) => item.id == id);

        // if naa sa breadcrumbs ang id (route change)
        if (index !== -1) {
            state.breadCrumb.data.splice(index + 1, state.breadCrumb.data.length);
        }
        // if wala means sa tree siya nag tuplok (route change)
        else{
            let storeBreadCrumbs = (localStorage.getItem("BREADCRUMBS") !== null) ? JSON.parse(localStorage.getItem("BREADCRUMBS")) : [];

            let obj = storeBreadCrumbs?.find(e => e.id === parseInt(id));

            if(obj && obj !== undefined && obj !== null){
                state.breadCrumb.data = obj.breadcrumbs || [];
            }
            else{

                if(state.breadCrumb.data.length > 0 || state.breadCrumb.data !== undefined || state.breadCrumb.data !== null){
                    state.breadCrumb.data.splice(1, state.breadCrumb.data.length.length);
                }
                else{
                    state.breadCrumb.data = [
                        {
                            id: 0,
                            text: "My Folder",
                            to: { name: "My Folder" },
                        },
                    ]
                }

            }
        }

        // modify breadcrumbs
        const copyBreadcrumbData = (state.breadCrumb.data !== null) ? JSON?.parse(JSON.stringify(state.breadCrumb.data)) : [];
        state.modifyBreadCrumb.data = modifiedBreadCrumb(copyBreadcrumbData);
    },
    setBreadCrumbByTree: (state, data) => {
        if (data !== null) {
            state.breadCrumb.data = (data.breadcrumbs.length !== 0) ? data.breadcrumbs : [];
        }
        // empty na object means default route ni siya (My Folder)
        else {
            state.breadCrumb.data = [state.breadCrumb.data[0]];
        }

        // modify breadcrumbs
        const copyBreadcrumbData = JSON.parse(JSON.stringify(state.breadCrumb.data));
        state.modifyBreadCrumb.data = modifiedBreadCrumb(copyBreadcrumbData);
    },
    // eslint-disable-next-line no-unused-vars
    storeBreadCrumbs: (state, item) => {
        let storeBreadCrumbs = JSON.parse(localStorage.getItem("BREADCRUMBS"));

        if(storeBreadCrumbs !== null && storeBreadCrumbs instanceof Array && typeof item === 'object'){
            // before e store e check if naay duplicate
            // if walay duplicate
            if (!storeBreadCrumbs.some(e => e.id === item.id)) {
                storeBreadCrumbs.push({
                    id: item.id,
                    name: item.name,
                    breadcrumbs: item.breadcrumbs,
                    depth: item.depth,
                });
                localStorage.setItem("BREADCRUMBS", JSON.stringify(storeBreadCrumbs));
            }
        }
        else{
            // make sure na ang item is object
            if(typeof item === 'object'){
                storeBreadCrumbs = [{
                    id: item.id,
                    name: item.name,
                    breadcrumbs: item.breadcrumbs,
                    depth: item.depth,
                }];

                localStorage.setItem("BREADCRUMBS", JSON.stringify(storeBreadCrumbs));
            }
        
        }
    },
}


export const actions = {
}


const modifiedBreadCrumb = (data) => {
  if(data.length >= 4){
    const sliceData = data.slice(1, data.length-2);

    data.splice(1, data.length-3, sliceData);
    
    return data;
  }

  return data;
};